import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class DayStock extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.title}>
                <h4>
                    <a title="封面">{content.title}</a>
                </h4>
            </div>
        );
    }
}

export default errorBoundary(DayStock);
